<template>
	<div>
		<div v-if="login=='doLoginBtn'" style="text-align:center;color:#888;padding-top:200px;">
			<div style="padding:10px;">user ID:<input type="text" v-model="form.userId"></div>
			<div style="padding:20px;">user name:<input type="text" v-model="form.userName"></div>
			<input type="button" value="open dialog" @click="doLogin" style="width:200px;height:40px;"/>
		</div>
		<div v-if="login=='logining'" style="text-align:center;color:#888;padding-top:400px;">
			 init …
		</div>
		<vue-advanced-chat
			v-if="login=='logined'"
			height="calc(100vh)"
			:current-user-id="currentUserId"
			:rooms="JSON.stringify(rooms)"
			:rooms-loaded="roomLoaded"
			load-first-room="false"
			show-add-room="false"
			show-audio="false"
			show-reaction-emojis="false"
			multiple-files="false"
			:message-selection-actions="[]"
			:message-actions="[]"
			:messages="JSON.stringify(messages)"
			:messages-loaded="messagesLoaded"
			accepted-files="image/png,image/jpeg"
			@send-message="sendMessageAndFile($event.detail[0])"
			@fetch-messages="fetchMessages($event.detail[0])"
		/>
	</div>
</template>

<script>
import { register } from 'vue-advanced-chat'
import { mapGetters } from 'vuex'
// import { register } from '../../vue-advanced-chat/dist/vue-advanced-chat.es.js'
register()
export default {
	data() {
		return {
			login:'',
			currentUserId: '',
			icon:'',
			rooms: [
			],
			roomLoaded:false,
			messages: [],
			messagesLoaded: false,
			currentRoomId:'',
			loopRequestNo:0,
			exit:false,
			form:{
				userName:'',
				userId:'',
			}
		}
	},
	mounted() {
		this.form.userId=window.localStorage.getItem("_haidialog_id");
		this.form.userName=window.localStorage.getItem("_haidialog_name");
		//this.reqRooms();
		this.init();
	},
	beforeDestroy(){
		this.loopRequestNo=0;
		this.exit=true;
	},
	computed: {
	    ...mapGetters([
	      'token'
	    ])
    },
	methods: {
		loop(){
			if(this.exit){
				return;
			}
			let reqNum=this.loopRequestNo;
			setTimeout(()=>{
				if(this.exit){
					return;
				}
				if(this.loopRequestNo==reqNum){
					reqNum++;
					this.loopRequestNo=reqNum;
					this.reqLeastMessages();
					this.loop();
				}
				
			},5000);
		},
		init(){
			let accessKey=this.getQueryString("accessKey");
			if(accessKey!=null&&accessKey.length>10){
				this.login='logining';
				let data={accessToken:accessKey}
				 this.$api.post("/clientChat/login",this,data,{},res=>{
				 	if(res.code==200){
				 		this.$store.commit("SET_TOKEN",res.data.token);
				 		this.currentUserId=res.data.userId;
				 		this.icon=res.data.icon;
				  	 	this.login='logined';
				  	 	this.reqRooms();
				 	}
			  	 
			  	 },error=>{
			  	 	
			  	 });
			}else{
				window.close();
				//this.login='doLoginBtn';
			}
		},
		 getQueryString(name) {
		 	let href=window.location.href;
		     let search=href.substr(href.indexOf("?"));
		     if(!search){
		         search=window.location.search;
		     }
		    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
		    var r = search.substr(1).match(reg);
		    if (r != null) return unescape(r[2]); 
		    return null;
		},
		doLogin(){
			if(this.$my.isEmpty(this.form.userId)){
				alert("please input your id");
				return;
			}
			if(this.$my.isEmpty(this.form.userName)){
				alert("please input your name");
				return;
			}
			let data={appCode:'test',secretKey:'test123',userId:this.form.userId,userName:this.form.userName,icon:'http://8.137.8.158/static/chat-kefu-upload/202410/sUbPna4FIfPcGqdinR6mIygORsteMU.jpg'}
			 this.$api.post("/forward/generate2",this,data,{},res=>{
			 	if(res.code==200){
			 			window.location.href=res.data.forwardUrl;
			 			window.localStorage.setItem("_haidialog_id",this.form.userId)
			 			window.localStorage.setItem("_haidialog_name",this.form.userName)
			 	}else{
			 		alert(res.msg);
			 	}
			 
		  	 },error=>{
		  	 });
		},
		reqRooms(){
			 let data={};
		  	 this.$api.post("/clientChat/room/list",this,data,{},res=>{
		  	 	  res.data.rooms.forEach(o=>{
		  	 	  	if(o.lastMessage&&o.lastMessage.lastTime){
		  	 	  		o.timestamp=new Date(o.lastMessage.lastTime).format("yyyy-MM-dd HH:mm");
		  	 	  	}
		  	 	  
		  	 	  });
		  	 	  this.rooms = res.data.rooms;
		  	 	  this.roomLoaded=true;
		  	 	  this.loop();
		  	 },error=>{
		  	 });
		},
		reqLeastMessages(){
			 let data={};
		  	 this.$api.post("/clientChat/takeLeastMessage",this,data,{},res=>{
		  	 	
		  	 	  if(res.data&&res.data.messages&&res.data.messages.length>0){
		  	 	  	res.data.messages.forEach(o=>{
		  	 			o.timestamp=new Date(o.createTime).format("HH:mm");
		  	 			o.date=new Date(o.createTime).format("yyyy-MM-dd");
		  	 		});
		  	 		let roomId=this.currentRoomId;
		  	 		let msgs=[];
		  	 		for(let i=0;i<res.data.messages.length;i++){
		  	 			let msg=res.data.messages[i];
		  	 			for(let j=0;j<this.rooms.length;j++){
	  	 					let room=this.rooms[j];
	  	 					if(room.roomId==msg.senderId){
	  	 						if(msg.senderId!=roomId){
	  	 						  room.unreadCount=room.unreadCount+1;
	  	 						}
	  	 						if(room.lastMessage){
	  	 							room.lastMessage.content=msg.content;
	  	 							room.lastMessage.timestamp=new Date(msg.createTime).format("yyyy-MM-dd HH:mm");
	  	 						}
	  	 						break;
	  	 					}
	  	 					
	  	 				}
		  	 			if(msg.senderId==roomId){
		  	 				msgs.push(msg);
		  	 			}
		  	 		}
		  	 		if(msgs.length>0&&this.currentRoomId==roomId){
		  	 			this.messages = [ ...this.messages,...msgs]
		  	 		}
		  	 		
		  	 		
		  	 	  }
		  	 },error=>{
		  	 });
		},
		
		fetchMessages({ room, options = {} }) {
			if (options.reset) {
				this.messagesLoaded=false;
				this.messages=[];
				this.currentRoomId=room.roomId;
			}
			if(room.unreadCount>0){
				room.unreadCount=0;
			}
			let loadMoreTime=0;
			if(this.messages.length>0){
				loadMoreTime=this.messages[0].createTime;
			}
		
			let data={roomId:room.roomId,loadMoreTime:loadMoreTime};
			this.$api.post("/clientChat/getMessages",this,data,{},res=>{
				if(res.data.roomId!=this.currentRoomId){
					return;
				}
		  	 	if(res.code==200){
		  	 		if(!res.data.more){
		  	 			this.messagesLoaded=true;
		  	 		}
		  	 		res.data.list.forEach(o=>{
		  	 			o.timestamp=new Date(o.createTime).format("HH:mm");
		  	 			o.date=new Date(o.createTime).format("yyyy-MM-dd");
		  	 		});
		  	 		this.messages = [...res.data.list, ...this.messages]
		  	 	}
		  	 },error=>{
		  	 	//this.messagesLoaded=true;
		  	 });
		},
		async compressBlob(blob, maxWidth,maxHeight) {
		  // 创建一个Image对象
		  const img = new Image();
		  // 将Blob转换为可以在Image对象中使用的URL
		  img.src = URL.createObjectURL(blob);
		 
		  await new Promise((resolve, reject) => {
		    img.onload = resolve;
		    img.onerror = reject;
		  });
		  // 创建一个Canvas元素
		  const canvas = document.createElement('canvas');
		  const ctx = canvas.getContext('2d');
		  
		  let scale=1.0;
		  if(img.width>maxWidth||img.height>maxHeight){
		  	scale=Math.min(maxWidth/img.width,maxHeight/img.height);
		  }
		  // 计算新的尺寸
		  const width = img.width * scale;
		  const height = img.height * scale;
		 
		  canvas.width = width;
		  canvas.height = height;
		  ctx.drawImage(img, 0, 0, width, height);
		 
		  return await new Promise((resolve, reject) => {
		    canvas.toBlob(blob => {
		      resolve(blob);
		    }, 'image/jpeg', 0.7); // 0.9是JPEG压缩质量，可以根据需要调整
		  });
		},
		async sendMessageAndFile(message){
			let files=[];
			const formData = new FormData();
			let imgs=[];
			if(message.content&&message.content.length>2000){
					alert("error send,message content length > 2000");
					return;
			}
        
			if(message.files&&message.files.length>0){
				if(message.files.length>3){
					alert("you can send less than three pictures")
					return;
				}
				for(let i=0;i<message.files.length;i++){
					let file=message.files[i];
					let f={
						extension: file.extension || file.type,
				        name: file.name,
				        size: file.size,
				        type: file.type,
				        url: file.url || file.localUrl
				       // preview: 'data:image/png;base64,iVBORw0KGgoAA...',
				       // progress: 100
				     };
				     //f.url='https://img1.baidu.com/it/u=1580190211,1100795495&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500'
					files.push(f);
					let blobUrl=file.localUrl;
					let urlBlob=null;
		        	await fetch(blobUrl).then(response => response.blob()).then(blob => {
		        	  urlBlob=blob;
		        	});
		        	
		    		await this.compressBlob(urlBlob, 800,800).then(compressedBlob => {
		    			urlBlob=compressedBlob;
				   	});
				   	imgs.push(urlBlob);
				  formData.append('imgFiles', urlBlob);
				}
			}
			
			let maxId=this.messages.length;
			if(this.messages.length>0){
				maxId=this.messages[this.messages.length-1]._id+1;
			}
			
			let send=	{
					_id: maxId,
					content: message.content,
					senderId: this.currentUserId,
					avatar:this.icon,
					timestamp: new Date().format("HH:mm"),
					date: new Date().format("yyyy-MM-dd"),
					files:files,
			};
			this.messages = [
				...this.messages,
				send
			]
			formData.append('toUserId',message.roomId);
			formData.append('msg',message.content);
			this.$api.postFile("/clientChat/sendMessageFiles",this,formData,{},res=>{
				  if(res.code==200){
				  	send._id=res.data.message._id;
				  	for(let i=0;i<files.length;i++){
				  		if(res.data.message.files.length>i){
				  			files[i].url=res.data.message.files[i].url;
				  		}
				  	}
				  }else{
				  	alert(res.msg);
				  }
		  	 },error=>{
		  	 	alert("send image fail");
		  	 });
			
		}
		
	}
}
</script>

<style lang="scss">
html,body{padding:0;margin:0;}
body {
	font-family: 'Quicksand', sans-serif;
}
</style>
